export default __webpack_public_path__ + "static/media/third-slide-small.06d163a8.jpg";